const TICKET_IS_FULL = "Ticket is full";
const NUMBER_IS_NOT_AVAILABLE = "Number is not available";
const TICKET_IS_NOT_FINISHED = "Ticket is not finished: %s";
const STUDENT_ALREADY_ASSIGNED_TO_THIS_TICKET = "Student already assigned to this ticket: %s";
const PDF_ALREADY_EXISTS = "Pdf already exists";
const PDF_NOT_EXISTS = "Pdf not exists";
const TICKET_IS_FINISHED_PDF_CAN_T_BE_DELETED = "Ticket is finished. Pdf can't be deleted";
const ANOTHER_TICKET_IN_PROGRESS = "You have already have another ticket in progress";
const STUDENT_NOT_ASSIGNED_TO_TICKET = "Student not assigned to ticket: %s";
const TICKET_IS_NOT_FULL = "Ticket is not full";
const DATABASE_ERROR = "Database error";
const TICKET_IS_ASSIGNED_TO_STUDENT = "Ticket is assigned to student";
const FAILED_TO_SAVE_PHOTO = "Failed to save photo";
const TASK_IMPORT_FAILED = "Task import failed";
const TASK_ALREADY_EXISTS = "Task already exists";

const RU_TICKET_IS_FULL = "Вариант заполнен";
const RU_NUMBER_IS_NOT_AVAILABLE = "Задача для этого номера уже добавлена";
const RU_TICKET_IS_NOT_FINISHED = "Есть незаконченный вариант";
const RU_STUDENT_ALREADY_ASSIGNED_TO_THIS_TICKET = "Вариант уже назначен ученику";
const RU_PDF_ALREADY_EXISTS = "PDF уже существует";
const RU_PDF_NOT_EXISTS = "PDF не существует";
const RU_TICKET_IS_FINISHED_PDF_CAN_T_BE_DELETED = "Вариант уже закончен, PDF нельзя удалить";
const RU_ANOTHER_TICKET_IN_PROGRESS = "Есть другой вариант в процессе создания";
const RU_STUDENT_NOT_ASSIGNED_TO_TICKET = "Вариант не назначен ученику";
const RU_TICKET_IS_NOT_FULL = "Вариант не заполнен";
const RU_DATABASE_ERROR = "Проблема при операции с БД";
const RU_TICKET_IS_ASSIGNED_TO_STUDENT = "Нельзя завершить вариант без задач, так как он назначен ученику";
const RU_FAILED_TO_SAVE_PHOTO = "Ошибка при сохранении фото";
const RU_TASK_IMPORT_FAILED = "Импорт задачи не удался";
const RU_TASK_ALREADY_EXISTS = "Эта задача уже существует";

class Messages {
    private static readonly mapping: Record<string, string> = {
        [TICKET_IS_FULL]: RU_TICKET_IS_FULL,
        [NUMBER_IS_NOT_AVAILABLE]: RU_NUMBER_IS_NOT_AVAILABLE,
        [TICKET_IS_NOT_FINISHED]: RU_TICKET_IS_NOT_FINISHED,
        [STUDENT_ALREADY_ASSIGNED_TO_THIS_TICKET]: RU_STUDENT_ALREADY_ASSIGNED_TO_THIS_TICKET,
        [PDF_ALREADY_EXISTS]: RU_PDF_ALREADY_EXISTS,
        [PDF_NOT_EXISTS]: RU_PDF_NOT_EXISTS,
        [TICKET_IS_FINISHED_PDF_CAN_T_BE_DELETED]: RU_TICKET_IS_FINISHED_PDF_CAN_T_BE_DELETED,
        [ANOTHER_TICKET_IN_PROGRESS]: RU_ANOTHER_TICKET_IN_PROGRESS,
        [STUDENT_NOT_ASSIGNED_TO_TICKET]: RU_STUDENT_NOT_ASSIGNED_TO_TICKET,
        [TICKET_IS_NOT_FULL]: RU_TICKET_IS_NOT_FULL,
        [DATABASE_ERROR]: RU_DATABASE_ERROR,
        [TICKET_IS_ASSIGNED_TO_STUDENT]: RU_TICKET_IS_ASSIGNED_TO_STUDENT,
        [FAILED_TO_SAVE_PHOTO]: RU_FAILED_TO_SAVE_PHOTO,
        [TASK_IMPORT_FAILED]: RU_TASK_IMPORT_FAILED,
        [TASK_ALREADY_EXISTS]: RU_TASK_ALREADY_EXISTS
    };

    // Ключи отсортированы по убыванию длины, чтобы более специфичные сообщения (например,
    // "Ticket is not finished" vs "Ticket is full") обрабатывались раньше.
    private static readonly sortedKeys: string[] = Object.keys(Messages.mapping).sort((a, b) => b.length - a.length);

    public static map(input: string): string | undefined {
        if (!input) return input;

        for (const eng of Messages.sortedKeys) {
            if (input.includes(eng)) {
                const ru = Messages.mapping[eng];
                // Заменяем первое вхождение английской фразы на русскую,
                // остальная часть строки (например, ": 123") сохраняется.
                return input.replace(eng, ru);
            }
        }

        return input;
    }
}

export default Messages;